import { render, staticRenderFns } from "./userPortrait.vue?vue&type=template&id=a4993a28&scoped=true"
import script from "./userPortrait.vue?vue&type=script&lang=js"
export * from "./userPortrait.vue?vue&type=script&lang=js"
import style0 from "./userPortrait.vue?vue&type=style&index=0&id=a4993a28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4993a28",
  null
  
)

export default component.exports